export default __webpack_public_path__ + "dddf8d13b791ce7ea80ac14b1f0f4425.png";